export default "__VITE_ASSET__B4vvTVF8__"